<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
    page: {
        title: "Audit Log",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            dtKey:0,
            title: "Audit Log",
            items: [
                {
                text: "Audit Log",
                href: "/",
                },
            ],
            date1: null,
        date: null,
        key:'',
        rangeDateconfig: {
          mode: "range",
          dateFormat: "d M, Y",
        },
        
            auditList:[],
            loadingDetail:true,
            ButtonSeen:true,
            event:'',
            auditable_type:'',
            old_values:'',
            new_values:'',
            username:'',
            created_at:'',
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        replaceWithBr(value) {
            return value.replace(/\n/g, "<br />")
        },
        getAuditList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'audit/list')
            .then(response => {
                if (response) {
                    this.loadingDetail=false;
                    this.auditList = response.data;
                    console.log(this.auditList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        search_logs(e)
        {
            this.ButtonSeen=true;
            e.preventDefault()
            
            const posting_ = {                
                date: this.date,
                key: this.key,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'audit/search', posting_)
            .then(response => {
                if (response) {
                    this.loadingDetail=false;
                    this.auditList = response.data;
                    this.dtKey +=1;
                    console.log(this.auditList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
    },

    mounted() {
        this.getAuditList();
        //this.get_country();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">

                        <div class="card-body border-bottom-dashed border-bottom">
                            <form @submit="search_logs">
                            <div class="row g-3">
                                <div class="col-xl-6">
                                <div class="search-box">
                                    <input type="text" class="form-control search"
                                    placeholder="Search for Key Identifier" v-model="key"/>
                                    <i class="ri-search-line search-icon"></i>
                                </div>
                                </div>
                                <!--end col-->
                                <div class="col-xl-6">
                                <div class="row g-6">
                                    <div class="col-sm-8">
                                    <div class="">
                                        <flat-pickr v-model="date" placeholder="Select date" :config="rangeDateconfig"
                                        class="form-control"></flat-pickr>
                                    </div>
                                    </div>

                                    <div class="col-sm-4">
                                    <div>
                                        <button type="submit" class="btn btn-danger w-100">
                                        <i class="ri-equalizer-fill me-2 align-bottom"></i>Filters
                                        </button>
                                    </div>
                                    </div>
                                    <!--end col-->
                                </div>
                                </div>
                            </div>
                            <!--end row-->
                            </form>
                        </div>
                        <div class="col-lg-12">
                            <div v-if='loadingDetail'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>No.</th>
                                            <th >Event</th>      
                                            <th >Module</th>      
                                            <th >Auditable ID</th>
                                            <th >Key Identifier</th>
                                            <th >Old Value</th>
                                            <th >New Value</th>
                                            <th >User</th>
                                            <th >Created Date</th>
                                            
                                            <!--th scope="col">Action</th-->
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in auditList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>                               
                                            <td>{{ item.event }}</td>
                                            <td>{{ item.module }}</td>
                                            <td>{{ item.auditable_id }}</td>
                                            <td>{{ item.unique_identifier }}</td>
                                            <td><span v-html="item.old_values"></span></td>
                                            <td><span v-html="item.new_values"></span></td>                                                                                                                                                                                                       
                                            <td>{{ item.username }}</td>                                          
                                            <td>{{ format_date(item.created_at) }}</td>                                                     
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>